// Photo picker window (MediaPicker): library grid, selection footer, viewer pick action and
// the "set as main" action on gallery thumbnails.
export const mediaPicker = {
  window: {
    titleSingle: "Choose a photo",
    titleMultiple: "Choose photos",
  },
  tabs: {
    library: "Library",
  },
  tile: {
    inGallery: "In gallery",
    current: "Selected",
    openViewer: "Large preview",
    used_one: "used {{count}}×",
    used_few: "used {{count}}×",
    used_other: "used {{count}}×",
  },
  // Label on a portrait photo in a picker opened from a hero slot (main photo, hero background).
  portrait: "portrait, will be cropped",
  footer: {
    cancel: "Cancel",
    add_one: "Add selected ({{count}})",
    add_few: "Add selected ({{count}})",
    add_other: "Add selected ({{count}})",
  },
  empty: {
    filtered: "No photo matches the filters.",
    none: "The library is empty.",
    clear: "Clear filter",
    upload: "Upload",
  },
  primary: {
    setPrimary: "Set as main",
  },
  viewer: {
    pick: "Select",
    picked: "Selected",
    pickInGallery: "Already in the gallery",
  },
};
